import {
  Box, Divider, Flex, Grid, IconButton, Image, Text, Drawer, DrawerBody, DrawerHeader, DrawerOverlay, DrawerContent, DrawerCloseButton, FormControl, FormLabel, Input, Button, useDisclosure, DrawerFooter, Switch, FormErrorMessage,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { EmployeerDetail, Experience, } from "./moda";
import ExperienceDetailLogo from "../../../../../assets/images/ExperienceDetailLogo.png";
import { useFetch } from "../../../../../hooks/useFetch";
import { CustomToast } from "../../../../../components";
import EditLogo from "../../../../../assets/images/EditLogo.svg";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useAuth } from "../../../../../hooks/useAuth";

type props = {
  employeeId: number | null;
  data?: EmployeerDetail;
  onComplete?: any;
};

const ExperienceDetail = ({ employeeId, data, onComplete }: props) => {
  const [loading, setLoading] = useState(false);
  const { addToast } = CustomToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { fetchApi } = useFetch(addToast);
  const { hasPermission } = useAuth();
  const [employeerDetail, setEmployeerDetail] = useState<
    EmployeerDetail | undefined
  >(data);

  const salaryCompensationSchema: any = yup.object().shape({
    previousExperienceInMonths: yup.number().nullable()
      .transform((value, originalValue) =>
        String(originalValue).trim() === "" ? null : value
      ).notRequired(),

    organization_Name: yup.string().when("previousExperienceInMonths", {
      is: (val: any) => val && val > 0,
      then: (schema) =>
        schema.required("Last Organisation Name is required when experience is greater than 0"),
      otherwise: (schema) => schema.notRequired(),
    }),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
    watch,
    register,
    reset,
  } = useForm<EmployeerDetail>({
    resolver: yupResolver(salaryCompensationSchema),
    defaultValues: data,
  });

  const onSubmit = async (data: any) => {
    data.empId = employeeId;
    let endpoint = `Hrlense_Employee/empExperienceDetails/${employeeId}`;
    const response = await fetchApi(endpoint, "PUT", data, null, "Experience Updated Successfully");
    if (response) {
      onComplete();
      onClose();
    }
  };

  function handleEditClick() {
    reset({
      organization_Name: data?.organization_Name,
      previousExperienceInMonths: data?.previousExperienceInMonths,
    });
    onOpen();
  }

  useEffect(() => {
    if (data) {
      setEmployeerDetail(data);
      reset(data); // also reset form with latest data
    }
  }, [data, reset]);

  return (
    <>
      <Box pt={2} mb={6} className="main">
        <Flex justify="space-between" align="center" mb={2} pl={5} pr={5}>
          <Flex align="center" gap={3}>
            <Image src={ExperienceDetailLogo} alt={"Benifits & ID Numberss"} />
            <Text className="font-poppins text_sm text_medium col">
              Experience
              <Text as={"span"} className="font-poppins text_xsm">
                (in month)
              </Text>
            </Text>
          </Flex>
          {hasPermission('Employee', 'UpdateExperienceDetail') && (  
          <IconButton
            aria-label="Edit"
            icon={<Image src={EditLogo} />}
            variant="none"
            onClick={() => handleEditClick()}
          />
          )}
        </Flex>

        <Box py={2} px={10} bg="#FFFFFF" borderRadius={8}>
          {Experience.map((data, index) => (
            <Grid key={index} templateColumns="1fr 1fr" alignItems="center" mb={2}>
              <Text
                className="font-poppins text_sm text_medium"
                color="rgba(102, 102, 102, 1)"
               
              >
                {data?.label}
              </Text>
              <Text className="font-poppins text_sm text_medium col">
                {data.formate && employeerDetail?.[data.key] !== undefined
                  ? data.formate(employeerDetail[data.key])
                  : employeerDetail?.[data.key]}
              </Text>
            </Grid>
          ))}
          {/* <Divider mt={2} /> */}
        </Box>
      </Box>

      <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="md">
        <DrawerOverlay />
        <form onSubmit={handleSubmit(onSubmit)}>
          <DrawerContent
            className="drawer"
            display="flex"
            flexDirection="column"
            height="100%"
          >
            <DrawerCloseButton />
            <DrawerHeader>Update Experience Detail</DrawerHeader>
            <DrawerBody pb="70px" flex={1} overflow="auto">
              <Box m={6}>
                <Grid templateColumns="1fr" gap={4}>
                  <FormControl isInvalid={!!errors.previousExperienceInMonths}>
                    <FormLabel>
                      Previous Experience{" "}
                      <Text as={"span"} className="font-poppins text_xsm">
                        (in month)
                      </Text>
                    </FormLabel>
                    <Controller
                      name="previousExperienceInMonths"
                      control={control}
                      render={({ field }) => <Input type="number" {...field} 
                      maxLength={3}
                      onChange={(e) => {
                      let value = e.target.value;
                      // Sirf digits allow karo (0–9), baaki sab hata do
                      value = value.replace(/[^0-9]/g, "");
                      if (value.length > 3) {
                      value = value.slice(0, 3);
                      }
                      field.onChange(value);
                      }}
                      onKeyDown={(e) => {
                      // Prevent +, -, e, E, ., etc.
                      if (["-", "+", ".", "e", "E"].includes(e.key)) {
                      e.preventDefault();
                      }
                      }}
                      onPaste={(e) => {
                      // Prevent paste of non-numeric chars
                      const pasteData = e.clipboardData.getData("text");
                      if (!/^\d+$/.test(pasteData)) {
                      e.preventDefault();
                      }
                      }}/>}
                      
                    />
                    <FormErrorMessage>
                      {errors.previousExperienceInMonths?.message}
                    </FormErrorMessage>
                  </FormControl>

                  <FormControl isInvalid={!!errors.organization_Name}>
                    <FormLabel>Last Organisation Name</FormLabel>
                    <Controller
                      name="organization_Name"
                      control={control}
                      render={({ field }) => <Input type="string" {...field} 
                      
                      />}
                    />
                    <FormErrorMessage>
                      {errors.organization_Name?.message}
                    </FormErrorMessage>
                  </FormControl>
                </Grid>
              </Box>
            </DrawerBody>

            <DrawerFooter>
              <Button className="btn_theme" type="submit">
                Update Details
              </Button>
            </DrawerFooter>
          </DrawerContent>
        </form>
      </Drawer>
    </>
  );
};

export default ExperienceDetail;
